import { Component, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  FormGroup,
  TouchedChangeEvent,
} from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';
import { PaymentAuthorizationChannel } from '../../models';

@Component({
  selector: 'payment-ach-authorization-method',
  templateUrl: './ach-authorization-method.component.html',
  styleUrls: ['./ach-authorization-method.component.scss'],
})
export class AchAuthorizationMethodComponent implements OnInit {
  @Input()
  controlName: string;

  authorizationMethods: SelectItem<string>[];
  severity$ = new BehaviorSubject<string>('info');
  form: FormGroup;

  private control: AbstractControl;
  private subSink = new SubSink();

  constructor(
    @Optional()
    @SkipSelf()
    private controlContainer: ControlContainer,
  ) {
    this.setDropdownItems();
  }

  ngOnInit(): void {
    this.initializeFormControl();
  }

  private initializeFormControl() {
    this.form = this.controlContainer.control as FormGroup;
    this.control = this.controlContainer.control.get(this.controlName);

    this.subSink.add(
      this.control.valueChanges.subscribe(() => {
        this.updateSeverity();
      }),
    );

    this.subSink.add(
      this.control.events.subscribe((ev) => {
        if (ev instanceof TouchedChangeEvent) {
          this.updateSeverity();
        }
      }),
    );
  }

  private updateSeverity() {
    let severity = this.control.touched ? 'error' : 'info';

    if (this.control.value != null) {
      severity = 'success';
    }

    this.severity$.next(severity);
  }

  private setDropdownItems() {
    this.authorizationMethods = [
      {
        label: 'ARC_PAYMENT_AUTH_CHANNEL_PHONE',
        value: PaymentAuthorizationChannel.Phone,
      },
      {
        label: 'ARC_PAYMENT_AUTH_CHANNEL_MAIL',
        value: PaymentAuthorizationChannel.Mail,
      },
      {
        label: 'ARC_PAYMENT_AUTH_CHANNEL_WEBSITE',
        value: PaymentAuthorizationChannel.Website,
      },
    ];
  }
}
